import React, { useEffect, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Link from '@material-ui/core/Link';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { CircularProgress, Checkbox } from '@material-ui/core';
import {
  FROM_SERVER_TO_WEB_CHANNEL,
  FROM_WEB_TO_SERVER_CHANNEL,
  FROM_SERVER_TO_DASHBOARD_CHANNEL,
  makeRequest,
  makeRequestBySelfiID,
} from './api';
import QrReader from 'react-qr-reader';
import QRCode from 'qrcode.react';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import crypto from 'crypto';
import LandingPage from './LandingPage';
import Logo from './assets/images/okularlogin.svg';
import { getAblyToken } from './ably';
import { Realtime } from 'ably';
import jwt_decode from 'jwt-decode';
import { Strings } from './Strings';
import ScanGIF from './assets/images/scan.gif';
import Axios from 'axios';

function Copyright() {
  const classes = useStyles();
  return (
    <div style={{ marginBottom: 10 }}>
      <div className={classes.common_link}>
        <Typography variant='p' color='textSecondary' align='center'>
          <Link
            className={classes.link}
            color='inherit'
            href={process.env.REACT_APP_TERMS_AND_CONDITIONS}
          >
            {Strings.TERMS_AND_CONDITIONS}
          </Link>
          <Link
            className={classes.link}
            color='inherit'
            href={process.env.REACT_APP_PRIVACY_POLICY}
          >
            {Strings.PRIVACY_POLICY}
          </Link>
        </Typography>
      </div>
      <div className={classes.common_link}>
        <Typography variant='p' color='textSecondary' align='center'>
          {Strings.COPYRIGHTS_TEXT}
        </Typography>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  passloq_logo: {
    width: 165,
    marginBottom: 30,
    marginTop: 30,
  },
  bottom_content: {
    marginTop: 'auto',
  },
  link: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  common_link: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: 'small',
  },
}));

export default function SignIn(props) {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [qrLoading, setQrLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState(false);
  const [challengeId, setChallengeId] = useState(null);
  const [progressMessage, setProgressMessage] = useState(false);
  const [appId, setAppId] = useState('');
  const [encryptedNumber, setEncryptedNumber] = useState('');
  const [timeStamp, setTimeStamp] = useState('');
  const [hashKey, setHashKey] = useState('');
  const [randomNumber, setRandomNumber] = useState('');
  const [qrDetail, setQrDetail] = useState('');
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [method, setMethod] = useState(null);
  const [landing, setLanding] = useState(false);
  const [check, setcheck] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [applicationName, setApplicationName] = useState('');
  const [showScanGIF, setShowScanGIF] = useState(false);
  const [sessionData, setSessionData] = useState({});
  const [qrImgForWebqr, setQrImgForWebqr] = useState('');

  const handleCheck = () => {
    setcheck(!check);
  };

  const handlePress = async () => {
    try {
      setLoading(true);
      // let { sendChannel, recieveChannel } = getChannel();
      const challenge = getChallenge(setChallengeId);
      const dataToPost = {
        token: props.token || sessionData.token,
        appId: props.appId || sessionData.AppId,
        email: email.toLowerCase(),
        appChallengeId: challenge,
        sid: props.sid || sessionData.sid,
      };
      const token = await getAblyToken();
      const ably = new Realtime({ token });
      const channel = ably.channels.get(FROM_SERVER_TO_WEB_CHANNEL);
      channel.subscribe(email.toLowerCase(), function (message) {
        if (message.data.success) {
          if (message.data.redirect) {
            if (message.data.appChallengeId === challenge) {
              setLoading(false);
              setProgressMessage(message.data.message);
              const data = message.data.finalUrl.replace('#', '?');
              const sub_sid = new URL(data).searchParams.get('sub_sid');
              sessionStorage.setItem('sub_sid', sub_sid);
              setTimeout(() => {
                window.location.replace(message.data.finalUrl);
              }, 3000);
            } else {
              setError(Strings.CHALLENGE_NOT_MATCH);
              setLoading(false);
            }
          } else {
            setError(false);
            setProgressMessage(message.data.message);
          }
        } else {
          setError(message.data.message);
          setProgressMessage(false);
          setLoading(false);
          channel.unsubscribe(email.toLowerCase());
        }
      });

      await makeRequest('post', 'handleWebRequest', dataToPost);
    } catch (err) {
      console.log('Error', err);
      setLoading(false);
      setProgressMessage(false);
      setError(Strings.ERROR_REQUEST_TO_SERVER);
    }
  };

  const encryptData = async (ranNum) => {
    const data = {
      plainText: `${ranNum}`,
    };
    const res = await makeRequestBySelfiID('post', 'encryptData', data);
    return res.data.data;
  };

  const subscribe = async (
    applicationId,
    encryptedNumber,
    time,
    ranNum,
    sid
  ) => {
    const token = await getAblyToken();
    const ably = new Realtime({ token });
    const recieveChannel = ably.channels.get(FROM_SERVER_TO_WEB_CHANNEL);
    recieveChannel.subscribe(
      `${applicationId}_${ranNum}`,
      async function (message) {
        const tokenData = message.data.token;
        const email = message.data.email;
        const number = message.data.key_no;
        if (encryptedNumber === number) {
          const data = {
            webNumber: encryptedNumber,
            appId: applicationId,
            sid: props.sid || sid,
            tokenData,
            email,
          };
          recieveChannel.subscribe(
            `${email}_${ranNum}`,
            async function (message) {
              if (message.data.success) {
                if (message.data.redirect) {
                  setProgressMessage(message.data.message);
                  setTimeout(() => {
                    if (message.data.finalUrl && message.data.finalUrl !== '') {
                      // window.location.href = message.data.finalUrl;
                      const data = message.data.finalUrl.replace('#', '?');
                      const sub_sid = new URL(data).searchParams.get('sub_sid');
                      sessionStorage.setItem('sub_sid', sub_sid);
                      window.location.replace(message.data.finalUrl);
                      // window.location.href = `${message.data.redirectUrl}?&token=${message.data.token}`;
                    }
                    //else {
                    // window.location.href = `${message.data.redirect}?token=${message.data.token}`;
                    // window.location.href = `?success=${message.data.redirect}&token=${message.data.token}`;
                    // }
                  }, 3000);
                } else {
                  setError(false);
                  setProgressMessage(message.data.message);
                }
              } else {
                setError(message.data.message);
                setProgressMessage(false);
                setQrLoading(false);
                recieveChannel.unsubscribe(`${email}_${ranNum}`);
              }
            }
          );
          const res = await makeRequest(
            'post',
            'handleQRCodeLoginRequest',
            data
          );
        } else {
          setError('Invalid Session');
          setProgressMessage(false);
          setQrLoading(false);
          recieveChannel.unsubscribe(`${applicationId}_${ranNum}`);
        }
      }
    );
  };

  const getUniquId = () => {
    let current_date = new Date().valueOf().toString();
    let random = Math.random().toString();
    let uniqueHash = crypto
      .createHash('sha1')
      .update(current_date + random)
      .digest('hex');
    return uniqueHash;
  };

  const getQRGenerateData = async (applicationId, sid) => {
    // let urlParams1 = new URLSearchParams(window.location.search);
    // appId = urlParams1.get('appId') || null;
    // console.log('appId', urlParams1.get('appId'))
    // console.log('sessionData.AppId', sessionData && sessionData.AppId)
    // setAppId(appId);
    const appid = applicationId || appId || sessionData.AppId;
    const ranNum = Math.floor(Math.random() * 90000) + 10000;
    setRandomNumber(ranNum);
    const encryptedNumber = await encryptData(ranNum);
    setEncryptedNumber(encryptedNumber);
    const time = moment().utc().toISOString();
    setTimeStamp(time);
    const hash = crypto
      .createHash('sha256')
      .update(`${ranNum}${time}`)
      .digest('hex');
    setHashKey(hash);

    const session = await getUniquId();

    const qrdata = JSON.stringify({
      appId: appid,
      number: encryptedNumber,
      hashKey: hash,
      timeStamp: time,
    });

    await setQrDetail(qrdata);
    if (sid !== '' && sid !== null) {
      subscribe(appid, encryptedNumber, time, ranNum, sid);
    } else {
      subscribe(appid, encryptedNumber, time, ranNum);
    }
  };

  useEffect(async () => {
    const isToken = window.location.href.includes('token=');
    const isSession =
      window.location.href.includes('session=') || props.session !== '';
    let urlParams1 = new URLSearchParams(window.location.search);

    let landing, data, appId;
    if (isToken) {
      let token = urlParams1.get('token');
      let method = urlParams1.get('method');
      let success = urlParams1.get('success');
      appId = urlParams1.get('appId');
      let decoded = jwt_decode(token);
      setCompanyName(decoded.companyName);
      setApplicationName(decoded.applicationName);
      setAppId(appId);
      setMethod(method);
      landing =
        window.location.href.includes('success=') && success ? success : null;
    }

    if (isSession) {
      let session = urlParams1.get('session');
      const params = {
        sessionId: session || props.session,
      };
      let sessionRes = await Axios({
        method: 'get',
        url: `https://us-central1-trusloq.cloudfunctions.net/openAPI/getUserSession`,
        params,
      });
      if (sessionRes.data.success) {
        data = sessionRes.data.data;
        appId = data.AppId;
        setMethod(data.method);
        setSessionData(data);
        setCompanyName(data.companyName);
        setApplicationName(data.applicationName);
        setAppId(data.AppId);
        landing = data.success && data.success ? data.success : null;
      }
    }
    if (landing === 'true') {
      setLanding(true);
    }

    if (landing !== 'true') {
      if (isSession) {
        getQRGenerateData(appId, data.sid);
      } else {
        getQRGenerateData(appId);
      }
    }

    let interval = setInterval(getQRGenerateData, 180000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const onClickVerifyFaceOTP = async () => {
    if (email.toLowerCase()) {
      setLoading(true);
      const token = await getAblyToken();
      const ably = new Realtime({ token });
      const channel = ably.channels.get(FROM_SERVER_TO_DASHBOARD_CHANNEL);

      const challengeId =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      const data = {
        appId: props.appId || sessionData.AppId,
        email: email.toLowerCase(),
        appChallengeId: challengeId,
        sid: props.sid || sessionData.sid,
        openId: true,
        linkedSession: props.session,
        method
      };

      let response = await makeRequest('post', 'genFaceOTP', data);
      if (response.data.success) {
        if (method === 'webqr') {
          const data = { sessionId: response.data.data };
          const res = await makeRequestBySelfiID('post', 'getSession', data);
          await setQrImgForWebqr(
            'data:image/jpeg;base64,' + res.data.data.qrdata
          );
        }
        if (method !== 'webqr') {
          setProgressMessage(Strings.OTP_REQUEST_SENT);
        }
        setShowScanGIF(true);
        channel.subscribe(`session/${response.data.data}`, function (message) {
          if (
            (message.data.message === 'success',
            message.data.appChallengeId === challengeId)
          ) {
            setTimeout(() => {
              setEmail('');
            }, 500);
            setLoading(false);
            setShowScanGIF(false);
            // window.open(message.data.finalUrl, '_self');
            window.location.replace(message.data.finalUrl);
          } else {
            setError(message.data.message);
            setTimeout(() => {
              setEmail('');
            }, 500);
            setShowScanGIF(false);
          }
        });
      } else {
        setError(response.data.message);
        setLoading(false);
      }
    }
  };

  const handleScan = async (data) => {
    // let { sendChannel, recieveChannel } = getChannel();
    if (data && data !== null && data !== undefined) {
      setTimeout(async () => {
        setQrLoading(true);
      }, 200);

      const email = JSON.parse(data).email;
      const token = await getAblyToken();
      const ably = new Realtime({ token });
      const recieveChannel = ably.channels.get(FROM_SERVER_TO_WEB_CHANNEL);

      recieveChannel.subscribe(email, function (message) {
        if (message.data.success) {
          if (message.data.redirect) {
            setProgressMessage(message.data.message);
            setTimeout(() => {
              // window.location.href = `${message.data.redirect}?token=${message.data.token}`;
              window.location.href = `?success=${message.data.redirect}&token=${message.data.token}`;
            }, 3000);
          } else {
            setError(false);
            setProgressMessage(message.data.message);
          }
        } else {
          setError(message.data.message);
          setProgressMessage(false);
          setQrLoading(false);
          recieveChannel.unsubscribe(email);
        }
      });
    }
    if (data && data !== null && data !== undefined)
      await makeRequest(
        'post',
        'handleQRScannerRequestLogin',
        JSON.parse(data)
      );
  };
  const handleError = (err) => {
    if (err) {
      setTimeout(() => {
        enqueueSnackbar(Strings.CAMERA_NOT_AVAILABLE, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          persist: false,
        });
      }, 1000);
    }
  };

  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      {!landing ? (
        <>
          {' '}
          <div className={classes.paper}>
            <img
              src={Logo}
              alt={Strings.LOGO_TEXT}
              className={classes.passloq_logo}
            />
            {showScanGIF ? (
              <img
                src={ScanGIF}
                alt={Strings.LOGO_TEXT}
                style={{ width: 60, marginBottom: 15 }}
              />
            ) : (
              <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
              </Avatar>
            )}
            <Typography component='h1' variant='h5'>
              {`${Strings.SIGN_IN_FOR} ${applicationName}`}
            </Typography>
            <Error text={error} />
            <Progress text={progressMessage} />
            <form
              className={classes.form}
              noValidate
              onSubmit={(e) => {
                e.preventDefault();
                if (method === 'otp' || method === 'webqr') {
                  onClickVerifyFaceOTP();
                } else {
                  handlePress();
                }
              }}
            >
              <div
                style={{
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  marginTop: 10,
                }}
              >
                {qrLoading ? (
                  <div
                    style={{
                      width: '40%',
                      alignSelf: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: 200,
                    }}
                  >
                    <CircularProgress color='#fff' />
                  </div>
                ) : method === 'qrprof' ? (
                  <div
                    style={{
                      width: '40%',
                      alignSelf: 'center',
                      justifyContent: 'center',
                      borderStyle: 'groove',
                      borderWidth: 2,
                      display: 'flex',
                      paddingTop: 5,
                      paddingBottom: 5,
                      paddingLeft: 4,
                      paddingRight: 5,
                    }}
                  >
                    <QrReader
                      delay={500}
                      onError={handleError}
                      onScan={handleScan}
                      showViewFinder={false}
                      style={{ width: '100%' }}
                    />
                  </div>
                ) : (
                  ''
                )}
              </div>
              {method === 'qrprof' ? (
                <p
                  style={{
                    alignSelf: 'center',
                    color: 'gray',
                    marginRight: 10,
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                  {Strings.SCAN_YOUR_QR}
                </p>
              ) : (
                ''
              )}

              {(method === 'email' || method === 'otp' || method === 'webqr') &&
              !qrImgForWebqr ? (
                <>
                  <TextField
                    variant='outlined'
                    margin='normal'
                    required
                    fullWidth
                    id='email'
                    label={Strings.EMAIL_ADDRESS}
                    name='email'
                    autoComplete='email'
                    autoFocus
                    value={email}
                    style={{ marginBottom: 24 }}
                    onChange={(e) => {
                      setEmail(e.target.value.toLowerCase());
                      setSubscribed(false);
                    }}
                    placeholder={Strings.EMAIL_ADDRESS}
                  />

                  <FormControlLabel
                    style={{ alignItems: 'flex-start' }}
                    control={
                      <Checkbox
                        style={{
                          color: '#0066B3',
                          padding: '3px 9px 0px 9px',
                          backgroundColor: 'white',
                        }}
                        checked={check}
                        onChange={() => handleCheck()}
                      />
                    }
                    label={
                      <span style={{ fontSize: '17px' }}>
                        {`${Strings.OKULARID_SHARES}${applicationName}. ${Strings.PROVIDE_YOUR_CONSENT}`}
                      </span>
                    }
                  />
                  <Button
                    fullWidth
                    type='submit'
                    variant='contained'
                    color='primary'
                    className={classes.submit}
                    // onClick={handlePress}
                    style={{ paddingTop: '1rem', paddingBottom: '1rem' }}
                    disabled={
                      !check || !email || loading || email.trim().length === 0
                    }
                  >
                    {loading ? (
                      <CircularProgress color='#fff' />
                    ) : (
                      Strings.SIGN_IN
                    )}
                  </Button>
                </>
              ) : (
                ''
              )}

              {qrDetail && method === 'qrscan' ? (
                <>
                  <div
                    style={{
                      width: '100%',
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                      marginTop: 10,
                    }}
                  >
                    <div
                      style={{
                        alignSelf: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        paddingTop: 5,
                        paddingBottom: 5,
                        paddingLeft: 4,
                        paddingRight: 5,
                      }}
                    >
                      <QRCode size={150} value={qrDetail} />
                    </div>
                  </div>
                  <p
                    style={{
                      alignSelf: 'center',
                      color: 'gray',
                      marginRight: 10,
                      width: '100%',
                      textAlign: 'center',
                      marginBottom: 100,
                    }}
                  >
                    {Strings.SCAN_QR_CODE}
                  </p>
                </>
              ) : null}

              {qrImgForWebqr && method === 'webqr' ? (
                <>
                  <div
                    style={{
                      width: '100%',
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                      marginTop: 10,
                    }}
                  >
                    <div
                      style={{
                        alignSelf: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        paddingTop: 5,
                        paddingBottom: 5,
                        paddingLeft: 4,
                        paddingRight: 5,
                      }}
                    >
                      <img style={{ width: 200 }} src={qrImgForWebqr} />
                    </div>
                  </div>
                  <p
                    style={{
                      alignSelf: 'center',
                      color: 'gray',
                      marginRight: 10,
                      width: '100%',
                      textAlign: 'center',
                      marginBottom: 100,
                    }}
                  >
                    {Strings.SCAN_QR_CODE}
                  </p>
                </>
              ) : null}
            </form>
            <div style={{ marginTop: 'auto' }}>
              <Copyright />
            </div>
          </div>
        </>
      ) : (
        <LandingPage />
      )}
    </Container>
  );
}

function Error({ text }) {
  if (!text) {
    return null;
  }
  return (
    <Typography
      component='h3'
      style={{
        background: 'red',
        color: 'white',
        width: '100%',
        padding: '1rem',
        marginTop: '1rem',
        borderRadius: '10px',
      }}
      variant='body'
    >
      {text}
    </Typography>
  );
}
function Progress({ text }) {
  if (!text) {
    return null;
  }
  return (
    <Typography
      component='h3'
      style={{
        background: 'green',
        color: 'white',
        width: '100%',
        padding: '1rem',
        marginTop: '1rem',
        borderRadius: '10px',
      }}
      variant='body'
    >
      {text}
    </Typography>
  );
}

const getChannel = () => {
  let sendChannel = window.Ably.channels.get(FROM_WEB_TO_SERVER_CHANNEL);
  let recieveChannel = window.Ably.channels.get(FROM_SERVER_TO_WEB_CHANNEL);
  return { sendChannel, recieveChannel };
};
const getChallenge = (setChallengeId) => {
  const challengeId =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);
  setChallengeId(challengeId);
  return challengeId;
};
